import { AxiosResponse } from 'axios'
import { axiosClient } from '@App/api/api-client'
import Pathes from '@App/dicts/pathes'
import { YearToDatePayment } from '@Entities/processing/year-to-date-payment'
import { LastDistributionPayment } from '@Entities/processing/last-distribution-payment'
import { DistributionPaid } from '@Entities/processing/distribution-paid'

export const getEarningsYearToDate = (rightsholderId: number): Promise<AxiosResponse<YearToDatePayment>> =>
    axiosClient.get(Pathes.RightsHolder.paymentsYTD(rightsholderId))

export const getEarningsLastDistribution = (rightsholderId: number): Promise<AxiosResponse<LastDistributionPayment>> =>
    axiosClient.get(Pathes.RightsHolder.paymentsLastDistribution(rightsholderId))

export const getEarningsForDistributionPeriods = (
    rightsholderId: number,
    periodCount: number
): Promise<AxiosResponse<DistributionPaid[]>> =>
    axiosClient.get(Pathes.RightsHolder.paymentsForDistributions(rightsholderId, periodCount))
